export default class FooterState {
}